import { array, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';

export const Request = struct({
	organizationIds: array(OrganizationId),
});
